import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';

import styles from '../../../styles/pages/index.module.scss';
import { getList } from '../../api/Articles';
import { getCMSCategories } from '../../api/cms';
import CustomMetaHead from '../../components/CustomMetaHead';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import LayoutDynamic from '../../components/LayoutDynamic/LayoutDynamic';
import Navigation from '../../components/Navigation/Navigation';
import OrderAlertModal from '../../components/OrderAlertModal/OrderAlertModal';
import PageTitle from '../../components/Page Title/PageTitle';
import META_DATA from '../../constants/metaData';
import Loader from '../../store/loader';
import { getOrFetchFooterLinks } from '../../utils/footerLinks';
import { getOrFetchNavigationLinks } from '../../utils/navigationLinks';

export default function Ethima({ navigation, footerLinks, appLinks, categories, query, meta }) {
  const router = useRouter();

  const [ethima, setEthima] = useState();
  const [openModal, setOpenModal] = useState(false);

  const contentType = 'ethima';
  const { category, page } = router.query;
  const ETHIMA_LOADER_EVENT = 'ETHIMA_LOADING';

  useEffect(() => {
    Loader.addEvent(ETHIMA_LOADER_EVENT);
    async function fetchData() {
      const { data, error } = await getList(contentType, page, category);
      if (error) {
        router.push('/404');
        return;
      }
      setEthima(data);
      Loader.removeEvent(ETHIMA_LOADER_EVENT);
      if (!data?.data?.length) {
        if (category) {
          setOpenModal(true);
          return;
        }
        router.push('/404');
      }
    }
    fetchData();
  }, [category, page]);

  if (!ethima) return null;

  return (
    <>
      <CustomMetaHead meta={meta} />
      <div className={styles.headerContainer}>
        <Header navigation={navigation} />
        <Navigation navigation={navigation} />
      </div>
      <PageTitle title="Έθιμα του τόπου μας" />
      <LayoutDynamic
        data={ethima}
        appLinks={appLinks}
        path={router.pathname}
        categories={categories}
        contentName="ethima"
        query={query}
      />
      {openModal && (
        <OrderAlertModal
          isModalOpen={openModal}
          callback={() => {
            setOpenModal(false);
            router.push(`/${contentType}`);
          }}
          alertText="Δε βρέθηκαν αποτελέσματα για την κατηγορία που έχετε επιλέξει."
        />
      )}
      <Footer footerLinks={footerLinks} />
    </>
  );
}

export async function getStaticProps() {
  const [{ data: categories }, { data: navigation }, footerLinks] = await Promise.all([
    getCMSCategories('ethimaCategories'),
    getOrFetchNavigationLinks(),
    getOrFetchFooterLinks(),
  ]);

  const meta = META_DATA[process.env.appName].ethima;
  const appLinks = footerLinks?.appLinks?.data?.[0]?.fields || [];

  return {
    props: { navigation, footerLinks, appLinks, categories, meta },
  };
}
